import{e as s,m as r}from"./chunk-HBP5N4FR.js";import t from"bignumber.js";function T(e){return e.fee?e.fee:e.gasUsed===void 0?null:u(e)}var u,i=s(()=>{r();u=e=>{let n=new t(e.gasPrice),o=new t(e.gasUsed);return n.times(o).toString()}});export{T as a,i as b};
//# sourceMappingURL=chunk-BZYEY4V6.js.map
